import { Phone, MessageCircle, FileText } from "lucide-react";

/**
 * Mobile bottom action bar: Call · WhatsApp · Get Quote
 * Visible only on mobile via CSS class `.mobile-bottom-bar` defined in index.css.
 */
export default function FloatingCTA() {
  return (
    <>
      {/* Desktop floating WhatsApp button */}
      <a
        href="https://wa.me/64221012443?text=Hi%20Tribal%20Designz%2C%20I%27d%20like%20to%20enquire%20about%20custom%20Pacific%20uniforms"
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp"
        aria-label="WhatsApp Tribal Designz"
        className="hidden md:flex fixed bottom-6 right-6 z-50 items-center gap-2 bg-teal-400 text-zinc-950 font-bold uppercase tracking-wider px-5 py-4 shadow-2xl hover:scale-105 transition-transform"
      >
        <MessageCircle size={20} className="shrink-0" />
        <span className="text-sm">Chat on WhatsApp</span>
      </a>

      {/* Mobile bottom bar */}
      <div className="mobile-bottom-bar" data-testid="mobile-bottom-bar">
        <a href="tel:+64221012443" data-testid="bottom-call" className="action-call">
          <Phone size={18} />
          Call
        </a>
        <a
          href="https://wa.me/64221012443"
          target="_blank"
          rel="noreferrer"
          data-testid="bottom-whatsapp"
          className="action-wa"
        >
          <MessageCircle size={18} />
          WhatsApp
        </a>
        <a href="#contact" data-testid="bottom-quote" className="action-quote">
          <FileText size={18} />
          Get Quote
        </a>
      </div>
    </>
  );
}
